import React, { Component } from 'react';
import {Spinner, Row, Col, Button } from 'react-bootstrap';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {ClidReportGenerate, resetReport, ClidReportDownload, closeModalPopUp, BasedOnInventory} from './ReportsActions';
import { connect } from 'react-redux';	
import ShowModalPopUp from '../ShowModalPopUp';
import DatePicker from "react-datepicker";
import moment from "moment";
import ReportsViewSummary from './ReportsViewSummary';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import {URL_API_MANAGEMENT_SUMMARY_REPORT_GENERATE, URL_API_MANAGEMENT_SUMMARY_REPORT_EXCEL} from '../apiHitFile';
import _ from 'lodash';

 class managementSummary extends Component { 
  constructor(props){
    super(props)
    this.state= {
      selectedprocessName:[],
      saveClicked:false,
      GenerateReport:false,
      toggleA:true
    }
   }
  componentDidMount(){    
    this.props.BasedOnInventory()
    this.props.resetReport()
  }

  processNames = () => {
    const{processBasedValue} = this.props;
    let processNames=[];
    if(!_.isEmpty(processBasedValue)){
      processNames =  processBasedValue.processList
      }
    return processNames;
  }  
  
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({GenerateReport:false})
    }
  }
  handleChangeStart = (date) => {
    this.setState({startDate: date});
  }
  validateInput = () =>{
    const {selectedprocessName, startDate} = this.state
    if(!_.isEmpty(selectedprocessName) && typeof startDate !== "undefined"){
      return true
    }
  } 
  generateReport = () => {
    const {selectedprocessName, startDate} = this.state
    console.log('selectedprocessName', selectedprocessName)
    let obj = {
      'processes':{[selectedprocessName.inventoryProcessId]:selectedprocessName.inventoryProcessName},
      "date":moment(startDate).format('YYYY-MM-DD'), 
    }
    
    this.props.TokenValidation()
    this.props.ClidReportGenerate(obj, URL_API_MANAGEMENT_SUMMARY_REPORT_GENERATE)
    this.setState({GenerateReport:true})
    // this.setState({GenerateReport:true}, ()=>this.handleToggle())
  }
  handleToggle = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  downloadReport= () =>{
    const {selectedprocessName, startDate} = this.state
    let obj = {
      'processes':{[selectedprocessName.inventoryProcessId]:selectedprocessName.inventoryProcessName},
      "date":moment(startDate).format('YYYY-MM-DD'), 
    }
    
    // let obj =  {
    //   "region": "India",
    //   "center": "Tamil Nadu",
    //   "client": "Airtel",
    //    "month": "Sep",
    //    "year": "2019"
     
    // }
     this.props.TokenValidation()
     this.props.ClidReportDownload(obj, URL_API_MANAGEMENT_SUMMARY_REPORT_EXCEL, "MANAGEMENT_SUMMARY.xlsx")
   }

	render(){
    const {GenerateReport, toggleA} = this.state;    
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }		
		return(
			<div  className={(style) ? 'user' : "userSmall"}>			
				{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
        <div>
          <h6 onClick={this.handleToggle} >
          {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>&nbsp;REPORT CRITERIA</b></h6>  
        <div className={toggleA ? '': 'assesmentHide'}>  
          <Row className="marginBottom">  
          <Col>
          <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedprocessName}
          options={this.processNames()}
          onChange={this.handleSelectProcess}
          open={false}
          valueKey="inventoryProcessId"
          labelKey="inventoryProcessName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Process'
          dropdownHeight={600}
          />
          </Col>        
          <Col>
          <label><b>DATE<span className="RedColoring"> *</span></b></label>
          <DatePicker
          selected={this.state.startDate}
          className='myDatePicker'
          selectsStart
          showMonthDropdown
          startDate={this.state.startDate}
          onChange={this.handleChangeStart}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select Date"                   
         />
          </Col> 
          </Row> 
       </div>
          <Button className='buttonwidth alignInline alignRight' 
            onClick={this.generateReport}>Generate Report</Button>
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)  && !_.isEmpty(this.props.reportData.value)) ? 
          <Button className='buttonwidth alignInline alignRight' onClick={this.downloadReport}>Download Report</Button> : null}
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)) ?
          <ReportsViewSummary  reportData={this.props.reportData}/>
          : null }
        </div> 
			</div>)
	}

}
function mapStateToProps(state){
  return{
    size: state.UserReducer.large,    
    processBasedValue: state.ReportsReducer.processBasedValue,
    reportData: state.ReportsReducer.reportData, 
    isPending: state.ReportsReducer.isPending,
    showerror:  state.ReportsReducer.showerror, 
    errmessage:  state.ReportsReducer.errmessage,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  //actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  BasedOnInventory:  () =>dispatch(BasedOnInventory()),
  ClidReportGenerate: (a, b) => dispatch(ClidReportGenerate(a,b)),
  ClidReportDownload: (a, b, c) => dispatch(ClidReportDownload(a, b, c)),
  resetReport: () => dispatch(resetReport()),
  TokenValidation : () => dispatch(TokenValidation()),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  
})


export default connect(mapStateToProps, mapDispatchToProps)(managementSummary);     